import { commonService } from '.';
import axios from "axios";

const APIURL = process.env.PUBLIC_URL + "/api";
const cv2DcAsync = async (file, request) => {
    let idUser = request.idUser;
    let idDc = request.idDc;
    let idLang = request.idLang;
    let idCurrentLang = request.idCurrentLang;
    const endpoint = 'Cv2Dc/cv2dc?idUser=' + idUser + '&idDc=' + idDc + '&idLang=' + idLang + '&idCurrentLang=' + idCurrentLang;
    const url = `${APIURL}/` + endpoint;
    return await axios.post(url, file);
};

const downloadCV = (idDc, idLang) => {
    return commonService.getWithParam('Cv2Dc/getCV?idDc=' + idDc + '&idLang=' + idLang, null);
};

const downloadCVJson = (idDc, idLang) => {
    return commonService.getWithParam('Cv2Dc/getCVJson?idDc=' + idDc + '&idLang=' + idLang, null);
};

const getLogs = (start, end) => {
    return commonService.getWithParam('Cv2Dc/logs?start=' + (start ?? '') + '&end=' + (end ?? ''), null);
}

export const cv2DcService = {
    cv2DcAsync,
    downloadCV,
    downloadCVJson,
    getLogs
};